/**
 * React Query keys for HR schedules. Kept in a separate file so the hook module
 * can use Fast Refresh (only hook/component exports).
 */
export const SCHEDULES_QUERY_KEY = ['hr', 'schedules'];
export const SCHEDULE_DETAIL_QUERY_KEY = (id) => ['hr', 'schedules', 'detail', id];
